import { useEffect, useState } from 'react'
import { axiosPublic } from '../../publicRest'

export const useRealm = (): string | null => {
  const [realm, setRealm] = useState<string | null>(null)

  useEffect(() => {
    const fetchRealm = async () => {
      try {
        const response = await axiosPublic.get('/portalProperties')
        setRealm(response.data.keycloak.realm as string)
      } catch (error) {
        console.error('Erro ao buscar o realm:', error)
      }
    }

    fetchRealm()
  }, [])

  return realm
}
